export default __webpack_public_path__ + "static/media/5.1a569e6d.png";